"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var webEnquiriesCreatedTemplate = "\n<div class=\"ui-notification\">\n  <h3>Web Enquiries Created</h3>\n  <div class=\"message\">\n    {{count}} new web enquiries received. Click on to go do Dashboard\n    <br />  \n\n    <a class=\"btn btn-success\" ui-srefx=\"dashboard\" ng-click=\"viewDashoard()\">View Dashboard</a>\n  </div>\n</div>\n";

exports.default = webEnquiriesCreatedTemplate;


// WEBPACK FOOTER //
// ./client/app/common/templates/notification/webEnquiriesCreatedTemplate.js